<template>
  <b-card :header="caption">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="managersdetails" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="action" slot-scope="data">
        <button v-on:click="delmanager(data.item.id, data.item.managerId)">Delete</button>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(managersdetails)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>

let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/listDetails'
const API_DELETE = BASE + '/api/lockManagers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (id) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    managerId: id
  }
  let res = await postdata(API, parameters)
  return res.lockLists
}

async function deleteManager (lockManagerId, managerId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockManagerId: lockManagerId,
    managerId: managerId
  }
  let res = await postdata(API_DELETE, parameters)
  return res.lockManagers
}

export default {
  name: 'manager-list-detail',
  props: {
    caption: {
      type: String,
      default: 'Manager List Detail'
    }
  },
  data: () => {
    return {
      managersdetails: [],
      fields: [
        {key: 'id'},
        {key: 'startDate'},
        {key: 'endDate'},
        {key: 'lockAlias'},
        {key: 'lockName'},
        {action: 'Action'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.id).then(response => {
      this.$data.managersdetails = response
    })
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    delmanager (lockManagerId, managerId) {
      deleteManager(lockManagerId, managerId)
      location.reload()
    },
    getRowCount (managersdetails) {
      return managersdetails.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/ManagerListDetail.vue